import React, { lazy } from 'react';

import Partnerships from '../../../react4xp/components/Partnerships';
import Section from '../../../react4xp/components/Section';

function PartnetshipsPart(props) {
	return (
		<Section bgColor='bg-beige-primary-dark'
			children={
				<Partnerships 
					main={
						{
							title: props.title,
							intro: props.intro,
							img: props.image,
							cards: props.cards,
							cta: {
								label: props.ctaText,
								url: props.ctaButton,
							},
							color: props.color,
						}
					}
					sliderItems={props.trustedByLogos?.map(logo => ({ src: logo.link, alt: logo.alt })) || []}
					partnersTitle={props.trustedByHeading}
					successStories={
						{
							tag: props.successStoryTagline,
							title: props.successStoryTitle,
							quote: {
								text: props.successStoryText,
								author: props.successStoryName,
								position: props.successStoryPosition,
							},
							cta: props.successStoryCta,
							img: props.successStoryImage,
							orientation: "right"
						}
					}
					color={props.color}
				/>
			}
		/>
	)
}

export default (props) => <PartnetshipsPart {...props} />
